import {
    INITIATE_PROXY,
    INITIATE_PROXY_FAILURE,
    INITIATE_PROXY_SUCCESS,
    TERMINATE_PROXY_SUCCESS,
    TERMINATE_PROXY_FAILURE,
} from 'src/pages/more/pages/proxies/redux/action/actionTypes.js';

const initialState = {
    impersonationKey: '',
    statusCode: '',
    statusMessage: '',
    terminationStatusCode: '',
};

const InitiateProxyReducer = (state = initialState, action) => {
    switch (action.type) {
        case INITIATE_PROXY:
            return {
                ...state,
                statusCode: '',
                terminationStatusCode: '',
            };
        case INITIATE_PROXY_SUCCESS:
            return {
                ...state,
                impersonationKey: action.payload.impersonationKey,
                statusCode: action.payload.statusCode,
            };
        case INITIATE_PROXY_FAILURE:
            return {
                ...state,
                terminationStatusCode: '',
            };

        case TERMINATE_PROXY_SUCCESS:
            return {
                ...state,
                impersonationKey: '',
                terminationStatusCode: action.payload.statusCode,
                statusCode: '',
            };
        case TERMINATE_PROXY_FAILURE:
            return {
                ...state,
            };

        default: {
            return { ...state };
        }
    }
};

export default InitiateProxyReducer;
